import '.f8{max-width:560px;}.ssr-plugin'
import '.c0{padding:48px;}.ssr-plugin'
import '.fa{height:calc(100vh - 124px);}.ssr-plugin'
import '.ag{box-sizing:border-box;}.ssr-plugin'
import '.o{display:flex;}.ssr-plugin'
import '.p{flex-direction:column;}.ssr-plugin'
import '.bb{justify-content:center;}.ssr-plugin'
import '.cr{margin-bottom:24px;}.ssr-plugin'
import '.b6{margin-bottom:72px;}.ssr-plugin'
import { styled } from 'inlines'
import { Button } from '../../components/Button.js'
import { Icon } from '../../assets/icons/index.js'
import { colors } from '../../utils/colors.js'
import { TABLET, MOBILE, HEIGHT } from '../../utils/breakpoints.js'

export const StepTwo = ({ step, setStep, dictionary }) => {
  return (
    <styled.div className="f8 c0 fa ag o p bb"
      id="onboarding-step-two-content"
      style={{
        [TABLET]: {
          padding: '24px',
        },
        [MOBILE]: {
          height: 'calc(100dvh - 124px)',
          boxSizing: 'border-box',
          justifyContent: 'flex-end',
        },
      }}
    >
      <styled.div
        style={{
          [MOBILE]: {
            marginTop: '0px',
            marginBottom: '0px',
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
          },
        }}
      >
        <h2 className="cr">
          {dictionary.tutorialMaxVotes}
        </h2>
        <styled.h3 className="b6"
          style={{
            color: colors.primary,
            [MOBILE]: { marginBottom: 24 },
            [HEIGHT]: {
              marginBottom: '12px',
            },
          }}
        >
          {dictionary.tutorialVotePrice}
        </styled.h3>
      </styled.div>
      <Button
        ariaLabel={dictionary?.continueButton}
        id="onboarding-step-two-action-open-step-three"
        trailIcon={<Icon type="forwardIcon" color={colors.secondary} />}
        fullWidth
        onClick={() => setStep(step + 1)}
      >
        {dictionary?.continueButton}
      </Button>
    </styled.div>
  )
}
